import React, { Component, Fragment } from "react";
import CreateModel from "./CreateModel";
import FilterModel from "./FilterModel";
import { CSVLink } from "react-csv";
import List from "./List";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import { Multiselect } from 'multiselect-react-dropdown';
import {
    getAllrecords,
    records,
    record,
    remove,
    search,
    update,
    filter,
    filterAll
} from "../../../services/writer";
import Header from "../Header";

class Writers extends Component {
    csvLink = React.createRef();
    csvLink2 = React.createRef();
    state = {
        csvLoading_1:false,
        csvLoading_2:false,
        items: [],
        totalItems: [],
        totalFilteredItems: [],
        meta: {},
        query: "",
        filter: false,
        create: false,
        search: false,
        loading: true,
        applyFilter: false,
        tableCount: "hide",
        filterItem: "all",
        exportFileHeader: [
            { label: "Name", key: "name", name: "Name", id: "name", icon: "fas fa-user"}, 
            { label: "Email", key: "email", name: "Email", id: "email", icon: "fas fa-at"},  
            { label: "Interests", key: "insterests", name: "Interests", id: "insterests", icon: "fas fa-bars" },
            { label: "Why prowriter", key: "whyPW", name: "Why prowriter", id: "whyPW", icon: "fas fa-bars" },
            { label: "How did you hear about us", key: "how_did_you_find_us", name: "How did you hear about us", id: "how_did_you_find_us", icon: "fas fa-bars" },
            { label: "Date", key: "created_at", name: "Date", id: "created_at", icon: "fas fa-calendar-alt" },
            // { label: "Main Data", key: "data", name: "Main Data", id: "data", icon: "fas fa-database" },
            // { label: "Email Verified", key: "email_verified", name: "Email Verified", id: "email_verified", icon: "fas fa-envelope" },
            // { label: "Quiz Status", key: "quiz", name: "Quiz Status", id: "quiz", icon: "fas fa-bars" },
            // { label: "Status", key: "state", name: "Status", id: "state", icon: "fas fa-bell" },          
        ],
        writerColumns: [
            { label: "Name", key: "name", name: "Name", id: "name", icon: "fas fa-user" },           
            { label: "Email", key: "email", name: "Email", id: "email", icon: "fas fa-at" },
            { label: "Payment Method", key: "payment_method", name: "Payment Method", id: "payment_method", icon: "fa fa-credit-card" },
            { label: "Date", key: "created_at", name: "Date", id: "created_at", icon: "fas fa-calendar-alt" },
            { label: "Main Data", key: "data", name: "Main Data", id: "data", icon: "fas fa-database" },
            { label: "Membership", key: "membership", name: "Membership", id: "membership", icon: "fas fa-user-friends" },
            { label: "Interests", key: "insterests", name: "Interests", id: "insterests", icon: "fas fa-bars" },
            { label: "Type", key: "user_type", name: "Type", id: "user_type", icon: "fas fa-bars" },
            { label: "Why prowriter", key: "whyPW", name: "Why prowriter", id: "whyPW", icon: "fas fa-bars" },
            { label: "Freelancing experience", key: "freelancing_experience", name: "Freelancing experience", id: "freelancing_experience", icon: "fas fa-bars" },
            // { label: "Email preference", key: "user_email_preference", name: "Email preference", id: "user_email_preference", icon: "fas fa-envelope" }, 
            // { label: "Contact preference", key: "user_contact_preference", name: "Contact preference", id: "user_contact_preference", icon: "fas fa-bars" },
            { label: "How did you hear about us", key: "how_did_you_find_us", name: "How did you hear about us", id: "how_did_you_find_us", icon: "fas fa-bars" },
            { label: "Email Verified", key: "email_verified", name: "Email Verified", id: "email_verified", icon: "fas fa-envelope" },
            { label: "Quiz Status", key: "quiz", name: "Quiz Status", id: "quiz", icon: "fas fa-bars" },
            { label: "Status", key: "state", name: "Status", id: "state", icon: "fas fa-bell" },
            { label: "Public Url", key: "fullurl", name: "Public Url", id: "fullurl", icon: "fas fa-link" },
        ],
        restrictedCols: ['name','email'],
        defaultChecked: ['name', 'email','payment_method','user_type','whyPW','how_did_you_find_us','created_at'],
		isCols: false,
        isExport: false,
		isMenu: false,
        isFilterApplied: false,
        selectedFilter: []
    };
	
	handleCols = () => {
		this.setState({ isCols: this.state.isCols === true ? false : true })
	};
    handleExport = () => {
		this.setState({ isExport: this.state.isExport === true ? false : true })
	};
   
	handleMenu = () => {
		this.setState({ isMenu: this.state.isMenu === true ? false : true })
	};

    generateHeader = () => {
        let res=[];
        const cols = this.state.defaultChecked;
        for(var i =0; i < cols.length; i++){
            res.push(
                <th className="mid " key={'th_'+cols[i]+'_'+i}> {this.getColName(cols[i])}</th>
            )
        }
        
        return res;
    }

    handleColsToDisplay = e => {
        const selectedItem = e.target.name;
        const isChecked = e.target.checked; 
        if(isChecked && !this.state.defaultChecked.includes(selectedItem))
        {
            this.state.defaultChecked.push(selectedItem); 
            let addIndex = this.state.writerColumns.map(function(item) { return item.key; }).indexOf(selectedItem);
            this.state.exportFileHeader.push(this.state.writerColumns[addIndex]);
        }
        else
        {
            const index = this.state.defaultChecked.indexOf(selectedItem);
            if (index > -1) {
                this.state.defaultChecked.splice(index, 1);
            }
            let removeIndex = this.state.exportFileHeader.map(function(item) { return item.key; }).indexOf(selectedItem);
            this.state.exportFileHeader.splice(removeIndex, 1);

        }
              
        //console.log(this.state.defaultChecked,this.state.exportFileHeader);
        
    };

    generateCoulumsToDisplay = () => {
        let cols=[];
        for(var i =0; i < this.state.writerColumns.length; i++){
            cols.push(<li className="position-relative py-2 pr-3 text-left" key={this.state.writerColumns[i].key+'_'+i}><input type="checkbox" disabled={this.state.restrictedCols.includes(this.state.writerColumns[i].key)} defaultChecked={this.state.defaultChecked.includes(this.state.writerColumns[i].key)}  name={this.state.writerColumns[i].key} onChange={this.handleColsToDisplay}/><i className={this.state.writerColumns[i].icon}></i>{this.state.writerColumns[i].label} </li>)
        }
        return cols;
    }

    itemExists = (v) => {
        return this.state.writerColumns.some(function(el) {
          return el.key === v;
        }); 
    }

    getColName = (keyword) => {
        let data = this.state.writerColumns;
        let filtered = data.filter(entry => Object.values(entry).some(val => typeof val === "string" && val === keyword));
        return filtered[0].label;
    }

    delete = (id, item) => {
        return remove(id,item)
            .then(response => {
                let temp = this.state.items;
                for (var i in temp) {
                    if (temp[i].id === id) {
                        temp.splice(i, 1);
                        this.setState({ items: temp });
                    }
                }
            })
    };

    update = (id, item) => {
        return update(id, item).then(response => {
            if (item.state === 'rejected'){
                this.context.state.showCodeMessage('Writer verification declined' , 'success');
            }else if (item.state === 'approved'){
                this.context.state.showCodeMessage('Writer verification approved' , 'success') ;
            }
            let temp = this.state.items;

            for (var i in temp) {
                if (temp[i].id === id) {
                    temp[i] = response.data;
                    this.setState({ items: temp });
                }
            }
        });
    };

    toggleCreate = () => {
        this.setState({ create: this.state.create === true ? false : true });
    };

    toggleApplyFilter = () => {
        this.setState({ applyFilter: this.state.applyFilter === true ? false : true });
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };

    reloadItem = () => {
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    totalItems: response.meta.total_data,
                    totalFilteredItems: response.meta.total_filtered_data,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    
    record = id => {
        return record(id);
    };

    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };

    search = query => {
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    filter = item => {
        this.setState({ loading: true });
        filter(item).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                filter: true,
                loading: false,
                filterItem: item,
            });
        });
    };

    getFilterData = (responseData, selectItem) => {
        this.setState({
            items: responseData.data,
            meta: responseData.meta,
            totalItems: responseData.meta.total_data,
            totalFilteredItems: responseData.meta.total_filtered_data,
            filter: true,
            loading: false,
            isFilterApplied: true,
            selectedFilter: selectItem
        });
    }

    clear = () => {
        this.setState({ loading: true });
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    

    componentDidMount() {
        records(1)
            .then(response => {
                console.log(response);
                for (let i = 0; i < response.data.length; i++){
                    response.data[i].created_at = response.data[i].created_at.replaceAll("-","/");
                }

                this.setState({
                    items: response.data,
                    meta: response.meta,
                    totalItems: response.meta.total_data,
                    totalFilteredItems: response.meta.total_filtered_data,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    changePage = page => {
        if (this.state.search === true) {
            search(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else if (this.state.isFilterApplied === true){
            filterAll(this.state.selectedFilter, page).then(response => {
                // this.setState({ loading: false });
                // this.props.getFilterData(response, this.state.item);
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    filter: true,
                    loading: false,
                    isFilterApplied: true,
                    selectedFilter: this.state.selectedFilter
                });
            })
        } else {
            records(page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };

    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };

    generateTable = () => {
        this.setState({ isCols:false });
        this.filter("all");
    }
    getWriters = () => {
        this.setState({
            csvLoading_1: true,
          });
          getAllrecords()
            .then(response => {
                console.log(response);
                this.setState({
                    totalItems: response.data,
                  });
                  this.csvLink.current.link.click();
                  this.setState({
                    csvLoading_1: false,
                  });
            })
            .catch(error => {
                this.context.state.handelError(error);
                this.setState({
                    csvLoading_1: false,
                  });
            });
      }
      getFilterWriters = () => {
        this.setState({
            csvLoading_2: true,
          });
         
          if(this.state.totalFilteredItems.length > 0){
            this.csvLink2.current.link.click();
            this.setState({
              csvLoading_2: false,
            });
          }else{
            getAllrecords()
            .then(response => {
                this.setState({
                    totalFilteredItems: response.data,
                  });
                  this.csvLink2.current.link.click();
                  this.setState({
                    csvLoading_2: false,
                  });
            })
            .catch(error => {
                this.context.state.handelError(error);
                this.setState({
                    csvLoading_2: false,
                  });
            });
          }
          
      }
    
    render() {
        
        return (
            <Fragment>
                <Header></Header>
                <div className="main-content px-5 mt-6">
				    <div className="px-4">
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <div className="header">
                                        <div className="header-body">
                                            <div className="row align-items-center mb-4">
                                                <div className="col">
                                                    <h1 className="header-title">
                                                        Writers
                                                    </h1>
                                                    <h6 className="header-pretitle">
                                                        Overview all available
                                                        Writers
                                                    </h6>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        onClick={this.toggleCreate}
                                                        className="btn btn-primary"
                                                    >
                                                        Add Writer
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-lg-10 col-md-9 col-6">
                                                    <button className="d-md-none d-block export-btn" onClick={() => this.handleMenu()}><i className="mr-3 fas fa-bars"></i><i className="fas fa-caret-down"></i></button>
                                                    {/* <div className={this.state.isMenu ? 'export-btn-block menu lg collapse position-absolute show' : 'export-btn-block menu lg collapse position-absolute'}>
                                                        <ul className="writer-table nav nav-tabs flex-md-row flex-column nav-overflow header-tabs px-md-0 px-4">
                                                            <li className="nav-item">
                                                                <button
                                                                    onClick={() =>
                                                                        this.filter(
                                                                            "all"
                                                                        )
                                                                    }
                                                                    className={
                                                                        this.state
                                                                            .filterItem ===
                                                                            "all"
                                                                            ? `nav-link active`
                                                                            : `nav-link `
                                                                    }
                                                                >
                                                                    All{" "}
                                                                    <span className="badge badge-pill badge-soft-secondary">
                                                                        {
                                                                            this.state
                                                                                .meta
                                                                                .total
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </li>
                                                            <li className="nav-item">
                                                                <button
                                                                    onClick={() =>
                                                                        this.filter(
                                                                            "applied"
                                                                        )
                                                                    }
                                                                    className={
                                                                        this.state
                                                                            .filterItem ===
                                                                            "applied"
                                                                            ? `nav-link active`
                                                                            : `nav-link`
                                                                    }
                                                                >
                                                                    Applied{" "}
                                                                    <span className="badge badge-pill badge-soft-secondary">
                                                                        {
                                                                            this.state
                                                                                .meta
                                                                                .applied
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </li>

                                                            <li className="nav-item">
                                                                <button
                                                                    onClick={() =>
                                                                        this.filter(
                                                                            "approved"
                                                                        )
                                                                    }
                                                                    className={
                                                                        this.state
                                                                            .filterItem ===
                                                                            "approved"
                                                                            ? `nav-link active`
                                                                            : `nav-link`
                                                                    }
                                                                >
                                                                    Approved{" "}
                                                                    <span className="badge badge-pill badge-soft-secondary">
                                                                        {
                                                                            this.state
                                                                                .meta
                                                                                .approved
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </li>
                                                            <li className="nav-item">
                                                                <button
                                                                    onClick={() =>
                                                                        this.filter(
                                                                            "rejected"
                                                                        )
                                                                    }
                                                                    className={
                                                                        this.state
                                                                            .filterItem ===
                                                                            "rejected"
                                                                            ? `nav-link active`
                                                                            : `nav-link`
                                                                    }
                                                                >
                                                                    Declined{" "}
                                                                    <span className="badge badge-pill badge-soft-secondary">
                                                                        {
                                                                            this.state
                                                                                .meta
                                                                                .rejected
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </li>

                                                            <li className="nav-item">
                                                                <button
                                                                    onClick={() =>
                                                                        this.filter(
                                                                            "review"
                                                                        )
                                                                    }
                                                                    className={
                                                                        this.state
                                                                            .filterItem ===
                                                                            "review"
                                                                            ? `nav-link active`
                                                                            : `nav-link`
                                                                    }
                                                                >
                                                                    Re-review{" "}
                                                                    <span className="badge badge-pill badge-soft-secondary">
                                                                        {
                                                                            this.state
                                                                                .meta
                                                                                .review
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </li>
                                                            <li className="nav-item">
                                                                <button
                                                                    onClick={() =>
                                                                        this.filter(
                                                                            "completed"
                                                                        )
                                                                    }
                                                                    className={
                                                                        this.state
                                                                            .filterItem ===
                                                                            "completed"
                                                                            ? `nav-link active`
                                                                            : `nav-link`
                                                                    }
                                                                >
                                                                    Completed{" "}
                                                                    <span className="badge badge-pill badge-soft-secondary">
                                                                        {
                                                                            this.state
                                                                                .meta
                                                                                .completed
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div> */}
                                                </div>
                                              
                                                <div className="col-lg-2 col-md-3 col-6 text-right">
                                                    <div className="d-flex align-items-center justify-content-end">
					    							    <div className="mr-2">
					    						            <button className="export-btn" onClick={() => this.handleCols()}><i className="mr-3 fas fa-th"></i><i className="fas fa-caret-down"></i></button>
					    							        <div className={this.state.isCols ? 'export-btn-block lg collapse position-absolute show' : 'export-btn-block lg collapse position-absolute'}>
					    									    <h4 className="text-left p-3 font-weight-bold">Displayed User attributes</h4>
					    										<ul className="attribute-list pl-5">
                                                                    {this.generateCoulumsToDisplay()}
					    										</ul>
                                                                <button className="btn btn-primary d-block w-100" onClick={this.generateTable}>Generate Table</button>
                                                            </div>	
					    							    </div>
                                                        <div className="mr-2">
					    							    	<button className="export-btn" onClick={() => this.handleExport()}><i className="mr-3 fas fa-cloud-download-alt"></i><i className="fas fa-caret-down"></i></button>
					    							        <div className={this.state.isExport ? 'export-btn-block collapse position-absolute show' : 'export-btn-block collapse position-absolute'}>
                                                                {/* <CSVLink className="position-relative btn text-left d-block" filename={"all_writers.csv"} data={this.state.totalItems} headers={this.state.writerColumns}> <i className="position-absolute mr-2 fas fa-bars" aria-hidden="true"></i>All </CSVLink>
                                                                <CSVLink className="position-relative btn text-left d-block" filename={"writers.csv"} data={this.state.totalFilteredItems} headers={this.state.exportFileHeader}> <i className="position-absolute mr-2 fas fa-filter" aria-hidden="true"></i>Filtered </CSVLink> */}
                                                                {this.state.csvLoading_1 ?<div  className="position-relative btn text-left d-block" ><i className="position-absolute mr-2 fas fa-bars" aria-hidden="true"></i>Loading...</div>:<button className="position-relative btn text-left d-block" onClick={this.getWriters}> <i className="position-absolute mr-2 fas fa-bars" aria-hidden="true"></i>
                                                                All </button>} 
                                                                <CSVLink 
                                                                // className="position-relative btn text-left d-block"
                                                                className="hidden"
                                                                filename={"all_writers.csv"}
                                                                headers={this.state.writerColumns}
                                                                data={this.state.totalItems}
                                                                ref={this.csvLink}
                                                                /> 
                                                                {this.state.csvLoading_2 ?<div  className="position-relative btn text-left d-block" ><i className="position-absolute mr-2 fas fa-filter" aria-hidden="true"></i>Loading...</div>:<button className="position-relative btn text-left d-block" onClick={this.getFilterWriters}>  
                                                                <i className="position-absolute mr-2 fas fa-filter" aria-hidden="true"></i>
                                                                Filtered  </button>} 
                                                                <CSVLink 
                                                                // className="position-relative btn text-left d-block"
                                                                className="hidden"
                                                                filename={"writers.csv"}
                                                                headers={this.state.exportFileHeader}
                                                                data={this.state.totalFilteredItems}
                                                                ref={this.csvLink2}
                                                                /> 
					    							        </div>
					    							    </div>
                                                        <div>
                                                            <button className="filter-btn" onClick={() => this.toggleApplyFilter()}><i className="fas fa-filter"></i></button>
                                                        </div>
					    							</div>	
					    						</div>                    
                                            </div>
                                        </div>
                                    </div>
					    
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <form
                                                        onSubmit={this.submitSearch}
                                                        className="row align-items-center"
                                                    >
                                                        <div className="col-auto pr-0">
                                                            <span className="fe fe-search text-muted"></span>
                                                        </div>
                                                        <div className="col">
                                                            <input
                                                                onChange={this.onQueryChange.bind(
                                                                    this
                                                                )}
                                                                value={
                                                                    this.state.query
                                                                }
                                                                type="search"
                                                                className="form-control form-control-flush search"
                                                                placeholder="Search"
                                                            ></input>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive writes-table">
                                            {this.state.loading === true ? (
                                                <LoadingData></LoadingData>
                                            ) : this.state.items.length >= 1 ? (
                                                <table className="table table-sm table-nowrap card-table">
                                                    <thead>
                                                        <tr>
                                                            {/*<th>
					    									    <div className="custom-control custom-checkbox table-checkbox">
                                                                    #
                                                                </div>
					    					                </th>*/}
                                                            {this.generateHeader()}
                                                           
                                                            <th className="Options text-center">
                                                                {/* Options */}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="list">
                                                        {this.state.items.map(
                                                            (item, index) => {
                                                                return (
                                                                    <List
                                                                        getItem={
                                                                            this
                                                                                .record
                                                                        }
                                                                        update={
                                                                            this
                                                                                .update
                                                                        }
                                                                        delete={
                                                                            this
                                                                                .delete
                                                                        }
                                                                        reload={
                                                                            this
                                                                                .reloadItem
                                                                        }
                                                                        item={item}
                                                                        defaultCols={this.state.defaultChecked}
                                                                        index={
                                                                            index
                                                                        }
                                                                        key={index}
                                                                    ></List>
                                                                );
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <NoData></NoData>
                                            )}
                                        </div>
                                        <div>
                                            <Footer
                                                changePage={this.changePage}
                                                totalPages={this.state.meta.pages}
                                                curentPage={this.state.meta.page}
                                            ></Footer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>	
                    {this.state.create === true ? (
                        <CreateModel
                            create={this.create}
                            hideCreate={this.toggleCreate}
                            reloadItem={this.reloadItem}
                        ></CreateModel>
                    ) : null}
                    {this.state.applyFilter === true ? (
                        <FilterModel
                            hideFilter={this.toggleApplyFilter}
                            getFilterData={this.getFilterData}
                            selectedFilterData={this.state.selectedFilter}
                            isFilterApplied={this.state.isFilterApplied}
                        ></FilterModel>
                    ) : null}
                </div>
            </Fragment>
        );
    }
}
Writers.contextType = AppContext;
export default Writers;



// WEBPACK FOOTER //
// ./src/components/admin/writers/Writers.js